<template>
  <div class="no-elements">
    <v-img
      v-if="imageSrc"
      :src="imageSrc"
      max-width="150"
      class="mx-auto mb-4 imageOpacity"
      contain
    />

    <h2>{{ title }}</h2>
    <p class="description">{{ description }}</p>

    <v-btn
      v-if="buttonText"
      prepend-icon="mdi-plus"
      class="mt-4 white-text-button"
      color="accent"
      rounded="xl"
      elevation="0"
      @click="handleClick"
    >
      {{ buttonText }}
    </v-btn>
  </div>
</template>

<script setup>
    import { defineProps } from 'vue'

    const props = defineProps({
        title: { type: String, required: true },
        description: { type: String, required: true },
        imageSrc: { type: String, default: null },
        buttonText: { type: String, default: null },
        buttonAction: {
            type: [Function, String],
            default: null
        }
    })

    function handleClick() {
        if (!props.buttonAction) return

        if (typeof props.buttonAction === 'function') {
            props.buttonAction()
        }
    }
</script>

<style scoped>
    .no-elements {
      text-align: center;
      padding: 2rem;
    }

    .description {
      color: #666;
      margin-bottom: 1rem;
    }

    .imageOpacity {
      opacity: 0.1;
    }
</style>
